/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobThreadFrame {
    getFixupPrototypeFunction() { return BackgroundJobThreadFrame.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobThreadFrame>): BackgroundJobThreadFrame {
        let obj = Object.assign(new BackgroundJobThreadFrame(), model);
        BackgroundJobThreadFrame.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobThreadFrame>): BackgroundJobThreadFrame {
        if (!model) return null;
        return BackgroundJobThreadFrame.newInstance(<BackgroundJobThreadFrame> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobThreadFrame) {
        if (!obj) return;

        models.BackgroundJobThreadFrame.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobThreadFrame): boolean {
        Object.setPrototypeOf(obj, BackgroundJobThreadFrame.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.lineno === undefined) {
            this.lineno = 0;
        }
    }

    /**
     * Name of the file for the function
     */
    filename: string;

    /**
     * Number line for the function
     */
    lineno: number;

    /**
     * Name of the function
     */
    name: string;

    /**
     * Text of the line
     */
    line: string;

}
